import { render, staticRenderFns } from "./ProductEditTaxes.vue?vue&type=template&id=a9364818"
import script from "./ProductEditTaxes.vue?vue&type=script&lang=ts"
export * from "./ProductEditTaxes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports